export default {"src":"/_next/static/media/wbtc.9329a13b.svg","height":44,"width":44};